import { useEffect, useRef, useState } from "react";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import { useGetWidget } from "../../../../helpers/widget_helper";
import BoundWidget from "../../BoundWidget";
import Chart from "chart.js/auto";
import random_color from "../../../../helpers/random_color";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ModalDetail from "../../detail-modal";
import { Input } from "reactstrap";

const ChartBarVertical = ({ source, params }) => {
  const { loading, data, failed, getSource } = useGetWidget({ source, params });
  const [showValue, setShowValue] = useState(true)

  const [rcd, setRcd] = useState({
    data: null,
    datasets: [],
    ignoreColor: false,
  });

  const options = {
    responsive: true,
    indexAxis: 'y',
    maintainAspectRatio: false,

    plugins: {
      datalabels: {
        display: function (context) {
          return showValue ? context.dataset.data[context.dataIndex] >= 1 : false;
        },
        backgroundColor: function (context) {
          return context.dataset.backgroundColor;
        },
        borderRadius: 4,
        color: 'white',
        font: {
          weight: 'bold'
        },
        formatter: Math.round,
        padding: 6
      },

      legend: {
        position: "bottom",
        onClick(e, legendItem, legend) {
          const ci = legend.chart;
          ci.toggleDataVisibility(legendItem.index);
          ci.update();
        },
        labels: {
          generateLabels: (chart) => {
            const labels = chart.data.labels;
            const dataset = chart.data.datasets[0];
  
            return labels.map((label, index) => ({
              text: label,
              hidden: !chart.getDataVisibility(index),
              fillStyle: dataset.backgroundColor[index],
              index,
            }));
          }
        }
      },

      title: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: true,
        },
      },
    },
  };

  useEffect(() => {
    if (data) {
      let datasets = []

      data?.data?.map((value, i) => {
        datasets.push({
          background_color: data.background_color[i],
          border_color: data.border_color[i],
          data: [value],
          label: data.labels[i]
        })
      })
      if (data.datasets) {
        setRcd({
          labels: data.labels,
          datasets: data.datasets,
        });
      } else {
        let color = random_color(data.background_color)
        setRcd({
          labels: data.labels,
          datasets: 
          [
            {
              // label: data.labels,
              data: data.data,
              backgroundColor: color,
              borderColor: color,
            },
          ],
        });
      }
    }
  }, [data]);

  const [openModalDetail, setOpenModalDetail] = useState(false)
  const [child, setChild] = useState()
  function toggleOpenModalSave(child_data, label) {
    setChild({
      period: source?.split("=")[2],
      source: data.source,
      enpoint_root_id: data.endpoint_id,
      param_child: child_data?.toString(),
      childType: data.endpoint_child_type,
      type: data.type,
      condition: label
    })
    setOpenModalDetail(!openModalDetail);
  }

  const chartRef = useRef();
  const handleChartClick = async (e, source, data) => {
    if (getElementAtEvent(chartRef.current, e).length === 0 || data.endpoint_child.length === 0) return

    
    const index = getElementAtEvent(chartRef.current, e)[0].index;
    const label = chartRef.current.data.labels[index]
    // console.log(getElementAtEvent(chartRef.current, e).length, source)
    // console.log(source)
    toggleOpenModalSave(_, label)
  }

  return (
    <>
      <BoundWidget
        loading={loading}
        data={data}
        failed={failed}
        onReload={getSource}
      >
        {data && (
          <>
            <div style={{ height: "580px" }}>
              <Bar
                ref={chartRef}
                role="button"
                onClick={(e) => handleChartClick(e, source, data)} 
                options={options} data={rcd} plugins={[ChartDataLabels]} />{" "}
            {/* </div>
                <div className="d-flex gap-2 justify-content-center m-4 text-white">
                    {data.labels.map((value, idx) => (
                      <button onClick={() => hideBar(idx)} key={idx} className="btn btn-sm"  style={{backgroundColor: data.background_color[idx],  fontWeight: "bold"}}>{value}</button>
                    ) )}
                </div>
            <div> */}
              <Input
                className="cursor-pointer"
                type="checkbox"
                checked={showValue}
                onChange={() => setShowValue(!showValue)}
              />
              <span className="ms-2">Tampilkan Nilai</span>
            </div>
          </>
        )}
      </BoundWidget>
      <ModalDetail
        toggleOpenModalDetail={toggleOpenModalSave}
        openModalDetail={openModalDetail}
        child={child} // child: {type, data}
      />
    </>
  );
};

export default ChartBarVertical;
